import React from "react";
import { Box, Typography, TextField, Select, MenuItem } from "@mui/material";

interface FilterOption {
  label: string;
  value: string;
}

interface Props {
  title: string;

  // 🔍 Search
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;

  // 🔽 Filter
  filterValue?: string;
  onFilterChange?: (value: string) => void;
  filterOptions?: FilterOption[];
}

const PageHeader: React.FC<Props> = ({
  title,
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search...",
  filterValue,
  onFilterChange,
  filterOptions = [],
}) => {
  return (
    <Box className="booking-page-header">
      <Typography className="booking-title">{title}</Typography>

      <Box className="booking-actions">
        {/* 🔍 Search */}
        {onSearchChange && (
          <TextField
            placeholder={searchPlaceholder}
            size="small"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            sx={{ width: { xs: "100%", sm: 220 } }}
          />
        )}

        {/* 🔽 Filter */}
        {onFilterChange && (
          <Select
            size="small"
            value={filterValue || ""}
            displayEmpty
            onChange={(e) => onFilterChange(e.target.value)}
            sx={{ width: { xs: "100%", sm: 180 } }}
          >
            {filterOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        )}
      </Box>
    </Box>
  );
};

export default PageHeader;